module.exports = __webpack_public_path__ + "frontend/images/green/carousel/static/mobile/0@2.png?ae598ee9d71a96f207f1625aa1876fbf";